import React from "react";
import BulkUpdatePolygon from "../../components/BulkUpdatePolygon";

const BulkUpdatePolygonManager = (props) => {
    return <BulkUpdatePolygon />;
};

export default BulkUpdatePolygonManager;